import React from 'react';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIntlText, pathOr } from '../js/utilities';
import useSettings from "../hooks/settings";
import Checkbox from './checkbox.jsx';
import useAuth from '../hooks/auth';
import Select from 's2s-select';
import { withTheme } from 'styled-components';

const SettingsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  font-family: Open Sans;
  flex-direction: column;
  padding: 24px 24px 0 24px;
`;

const SettingsTitle = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
  line-height: 12px;
  padding: 10px 0 15px 0;
`;

const SettingsDescription = styled.div`
  color: #4c5863;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 10px;
`;

const SettingsItemContainer = styled.div`
  margin-bottom: 12px;
`;

const StyledCheckbox = styled(Checkbox)`  
  label {
    font-family: Open Sans;
    font-size: 14px;
    margin-left: 15px;
  }
  
  .CheckboxCustom[aria-checked=false] {
    background: ${({ theme }) => theme.checkbox.background};
    border-color: ${({ theme }) => theme.checkbox.borderColor};
  }
  
  .CheckboxCustom[aria-checked=true] {
    border-color: transparent;
  }
`;

const TroubleshootingSettings = (props) => {
  const { intl, history } = props;
  const [settings, { changeSettings }] = useSettings();
  const [auth] = useAuth();
  const handleChangeLogging = (isChecked) => {
    changeSettings({ "advancedLogging": isChecked }, intl);
  };

  const handleChangeViewAlerts = (selectedItem) => {
    if(selectedItem.value === "email") {
      sendLogsByEmail();
    } else if (selectedItem.value === "download") {
      downloadLogs();
    } else if (selectedItem.value === "view") {
      history.push('/alerts');
    }
  };

  const sendLogsByEmail = () => {
    downloadLogs();
    const subject = `SoftPhone Desktop Application Log`;
    const body = `Please attach file with logs and add any additional information for support to try and replicate a bug or other error:
      %0D%0A%0D%0A%0D%0A
      ${pathOr('Not defined', ['auth', 'current_extension', 'firstname'], auth)}
      ${pathOr('Not defined', ['auth', 'current_extension', 'lastname'], auth)}
      ${pathOr('Not defined', ['auth', 'current_extension', 'userId'], auth)}
      %0D%0A
      Phone number: ${pathOr('Not defined', ['auth', 'identity', 'aliases', 0, 'sms'], auth)}
      %0D%0A
      Location: ${pathOr('Not defined', ['auth', 'identity', 'address', 'city'], auth)}
                ${pathOr('Not defined', ['auth', 'identity', 'address', 'state'], auth)}
      %0D%0A
      Customer: ${pathOr('Not defined', ['auth', 'account', 'name'], auth)}
      %0D%0A
      %0D%0A`;

    setTimeout(() => {
      const mailAdress = `mailto: support@star2star.com?subject=${subject}&body=${body}`;
      if (typeof (window.openHelp) == 'function') {
        window.openHelp(mailAdress);
      } else {
        window.open(mailAdress);
      }
    });
  };

  const downloadLogs = () => {
    const link = document.createElement("a");
    // set csv filename
    link.download = 'starphoneLogs-' + Date.now() + '.json';
    // set href for file data to be the attachment to the response
    link.href = 'data:attachment/csv;charset=utf-8,' + encodeURI([...window.__ALL_LOGS].join('\n'));
    link.click();
  };

  return (
    <SettingsContainer
      className="NotificationsContainer"
    >
      <SettingsItemContainer>
        <SettingsTitle
          className="SettingsTitleStyles"
        >
          {getIntlText(props.intl, 'SETTINGS-ADVANCED-LOGGING', "Advanced Logging")}
        </SettingsTitle>
        <SettingsDescription
          className="SettingsDescriptionStyles"
        >
          {getIntlText(props.intl, 'SETTINGS-ADVANCED-LOGGING-DESCRIPTION', "When enabled the application will create advanced logs to help with the diagnosing of application errors.")}
        </SettingsDescription>
        <StyledCheckbox isChecked={settings.advancedLogging} cbChanged={handleChangeLogging} label={getIntlText(props.intl, 'SETTINGS-ADVANCED-LOGGING-ENABLE', "Enable advanced logging")} />
      </SettingsItemContainer>
      {settings.advancedLogging &&
        <SettingsItemContainer>
          <SettingsTitle className="SettingsTitleStyles">
            {getIntlText(props.intl, 'SETTINGS-ADVANCED-LOGGING-VIEW-ALERTS-TITLE', "View Alerts")}
          </SettingsTitle>
          <SettingsDescription className="SettingsDescriptionStyles">
            {getIntlText(props.intl, 'SETTINGS-ADVANCED-LOGGING-VIEW-ALERTS-DESCRIPTION', "Access a record of alerts and logs")}
          </SettingsDescription>
          <Select
            menuItems={settings && settings.viewAlerts ? settings.viewAlerts : []}
            selectedItem={settings && settings.selectedViewAlerts}
            cbOnValueChange={handleChangeViewAlerts}
            placeholder="View Alerts"
          />
        </SettingsItemContainer>
      }
    </SettingsContainer>
  );

};

TroubleshootingSettings.propTypes = {
  cbViewAlerts: PropTypes.func,
  intl: PropTypes.object,
  history: PropTypes.object,
};

TroubleshootingSettings.defaultProps = {
  cbViewAlerts: () => { console.log("please define a callback for cbViewAlerts in troubleshooting settings"); }
};

export default withTheme(TroubleshootingSettings);
